// extracted by mini-css-extract-plugin
export var cardHeader = "_k9-1";
export var contentCard = "_k9-0";
export var headerActions = "_k9-3";
export var reorderHandle = "_k9-5";
export var titleArea = "_k9-2";
export var titleAreaWithHandle = "_k9-4";